export default function getPaymentGateways(
  state = { error: null, success: null, processing: "" },
  action
) {
  switch (action.type) {

    case 'FETCH_PAYMENT_GATEWAYS_SUCCESS':
      return {...state, ...{success: action.success}};
    case 'FETCH_PAYMENT_GATEWAYS_ERROR':
      return {...state, ...{error: action.error}};
    case 'FETCH_PAYMENT_GATEWAYS_PROCESSING':
      return {...state, ...{processing: action.processing}};
    default:
      return state;
  }
}
